<template>
  <div>

    <!-- System description table -->
    <div class="card measures"
         qid="measures-section"
         id="update_measures"
    >
      <div class="card-body" style="overflow-x:auto;">
        <div class="row">
          <div class="col-sm-6">
            <div class="float-left">
              <h5 class="mb-2" qid="questions-table-title">
                {{ $t('projects.measures.related_measures_title') }}
              </h5>
            </div>
          </div>

          <div class="col-sm-6 text-right">
            <b-button class="btn btn-success ml-3 pl-3 pr-3 float-right"
                  @click="showCreateMCModal()"
                  variant="success"
                  qid="create-category-button"
                  :disabled="buttonDisabled"
            >
              <font-awesome-icon icon="plus"/> {{ $t('projects.measures.create_section_button') }}
            </b-button>
          </div>
        </div>

        <b-alert v-if="moveError.length"
                 v-model="showMoveError"
                 dismissible
                 variant="danger"
                 class="mt-3"
                 qid="create-mc-error"
        >
          {{ moveError }}
        </b-alert>

        <br>
        <!-- Measure categories -->
        <draggable v-model="categoryItems"
                   class="dragArea"
                   @start="drag=true"
                   @end="drag=false"
                   @change="postOrderCategories"
                   group="object"
                   handle=".dnd-drag-me">
                   <!--:options="{group: 'object', handle:'.dnd-drag-me'}">-->

          <div v-for="(object, index) in categoryItems"
               :key="index"
               class="dnd-row mt-3"
               :class="{ 'dnd-category-alternative': object.alternative === 1, 'dnd-category': object.alternative === 0 || object.alternative === null  || !object.alternative}"
          >
            <span style="cursor: move;" class="text-center dnd-drag-me" v-if="!buttonDisabled">
              <font-awesome-icon icon="grip-vertical" />
            </span>
            <span style="padding-left: 20px; padding-right: 20px;" class="text-center" v-if="buttonDisabled">
              <font-awesome-icon icon="grip-vertical" />
            </span>

            <span class="measure-category-block--title">
              <strong v-if="object && object.measure_category && object.measure_category.name" style="font-size:18px;">
                {{ object.measure_category.name }}
              </strong>
            </span>

            <span v-if="object" class="text-right float-right">
              <b-button
                    class="btn btn-edit pr-2"
                    qid="add-MC-modal"
                    variant="secondary"
                    @click="showCreateMModal(object)"
                    :disabled="buttonDisabled"
              >
                <span v-if="!buttonDisabled" class="mr-1">
                  <font-awesome-icon icon="plus"/> {{ $t('projects.measures.create_button') }}
                </span>
                <span v-if="buttonDisabled" class="mr-1">
                  <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/> {{ $t('projects.measures.create_button') }}
                </span>
              </b-button>

              <b-button
                    class="btn btn-edit pr-2"
                    qid="edit-p-modal"
                    variant="success"
                    @click="showEditMCModal(object)"
                    :disabled="buttonDisabled"
              >
                <span v-if="!buttonDisabled" class="mr-1">
                  <font-awesome-icon icon="pen"/>
                </span>
                <span v-if="buttonDisabled" class="mr-1">
                  <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                </span>
              </b-button>

              <b-button
                    class="btn btn-delete pr-2"
                    style="margin-right: 2rem"
                    qid="delete-p-modal"
                    variant="danger"
                    @click="showConfirmDeleteCategoryModal(object)"
                    :disabled="buttonDisabled"
              >
                <span v-if="!buttonDisabled" class="mr-1">
                  <font-awesome-icon icon="trash-alt"/>
                </span>
                <span v-if="buttonDisabled" class="mr-1">
                  <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                </span>
              </b-button>
            </span>

            <span class="measure-category-block--description" v-if="object.measure_category && object.measure_category.description && object.measure_category.description.length">
              <div v-if="object.measure_category.description && object.measure_category.description.length > 300">
                <p v-if="object.expanded" class="text-formatted">{{ object.measure_category.description }}</p>

                <p v-if="!object.expanded" class="text-formatted">{{ object.measure_category.description | truncate(300) }}</p>

                <div class="text-center mt-3" @click="object.expanded=!object.expanded">
                  <span class="cursor-pointer" v-if="!object.expanded">
                    <span class="mr-2">
                      {{ $t('system.view_more') }}
                    </span>
                    <font-awesome-icon icon="chevron-down"/>
                  </span>
                  <span class="cursor-pointer" v-if="object.expanded">
                    <span class="mr-2">
                      {{ $t('system.view_less') }}
                    </span>
                    <font-awesome-icon icon="chevron-up"/>
                  </span>
                </div>
              </div>

              <p v-if="object.measure_category && object.measure_category.description && object.measure_category.description.length <= 300" class="text-formatted">
                {{ object.measure_category.description }}
              </p>
            </span>


            <!-- Measures -->
            <draggable v-model="object.measureItems"
                       :id="'category-' + object.id"
                       class="dragArea"
                       :force-fallback="true"
                       @start="drag=true"
                       @end="drag=false"
                       @change="postOrderMeasures($event, object)"
                       group="measureItems"
                       handle=".dnd-drag-me">
                       <!--:options="{group: 'measureItems', handle:'.dnd-drag-me'}">-->

              <div v-for="(item, key) in object.measureItems"
                   class="dnd-row dnd-item"
                   :key="key"
                   :id="item.id">

                <span style="cursor: move;" class="text-center dnd-drag-me" v-if="!buttonDisabled">
                  <font-awesome-icon icon="grip-vertical" />
                </span>
                <span style="padding-left: 20px; padding-right: 20px;" class="text-center" v-if="buttonDisabled">
                  <font-awesome-icon icon="grip-vertical" />
                </span>

                <span class="measure-block--title">
                  <strong v-if="item && item.measure && item.measure.name" style="font-size:16px;">
                    {{ item.measure.name }}
                  </strong>
                  <br>
                </span>

                <span v-if="item && item.measure" class="text-right">
                  <b-button
                        class="btn btn-edit pr-2"
                        qid="edit-p-modal"
                        variant="success"
                        @click="showEditMModal(item)"
                        :disabled="buttonDisabled"
                  >
                    <span v-if="!buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="pen"/>
                    </span>
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                  </b-button>
                  <b-button
                        class="btn btn-delete pr-2"
                        qid="delete-p-modal"
                        variant="danger"
                        @click="showConfirmDeleteModal(item)"
                        :disabled="buttonDisabled"
                  >
                    <span v-if="!buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="trash-alt"/>
                    </span>
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                  </b-button>
                </span>

                <span class="measure-block--description">
                  <div v-if="item.measure.description && item.measure.description.length > 300">
                    <p v-if="item.expanded" class="text-formatted">{{ item.measure.description }}</p>

                    <p v-if="!item.expanded" class="text-formatted">{{ item.measure.description | truncate(300) }}</p>

                    <div class="text-center mt-3" @click="item.expanded=!item.expanded">
                      <span class="cursor-pointer" v-if="!item.expanded">
                        <span class="mr-2">
                          {{ $t('system.view_more') }}
                        </span>
                        <font-awesome-icon icon="chevron-down"/>
                      </span>
                      <span class="cursor-pointer" v-if="item.expanded">
                        <span class="mr-2">
                          {{ $t('system.view_less') }}
                        </span>
                        <font-awesome-icon icon="chevron-up"/>
                      </span>
                    </div>
                  </div>

                  <p v-if="item.measure.description && item.measure.description.length <= 300" class="text-formatted">
                    {{ item.measure.description }}
                  </p>
                </span>

              </div>
            </draggable>
          </div>
          <div class="dnd-row dnd-item text-center" v-if="!loading && !categoryItems.length">
            <h5 class="mt-3">
              {{ $t('system.no_results') }}
            </h5>
          </div>
          <div class="mt-3 mb-3" v-if="loading">
            <div class="swing-container">
              <div class="swing">
                <div class="swing-l"></div>
                <div></div>
                <div></div>
                <div></div>
                <div class="swing-r"></div>
              </div>
            </div>
          </div>
        </draggable>
        <br>

      </div>
    </div>


    <!-- Add measure -->
    <b-modal ref="add-measure" @hide="hideCreateMModal" modal-class="task-modal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideCreateMModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="create-m-title">
            {{ $t('projects.measures.create_button') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-m-error"
      >
        {{ error }}
      </b-alert>

      <b-form @submit="addMeasureFormSubmit" qid="create-m-form">
        <b-form-group>
          <span class="float-right cursor-pointer" @click="selectAllMeasures">
            {{ $t('projects.measures.add_all_measures') }}
          </span>
          <label qid="create-p-users-label">
            {{ $t('projects.measures.select_measure_label') }}
          </label>
          <div class="multiselect-row">
            <multiselect
                v-model="selectedMeasure"
                :options="measureItems"
                :multiple="true"
                :taggable="false"
                track-by="slug"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :placeholder="$t('projects.measures.select_measure_placeholder')"
                label="name"
                qid="create-p-users-select"
            >
            </multiselect>
            <b-button
                class="btn btn-secondary float-right"
                @click="showCreateMeasureModal()"
                v-b-tooltip.hover
                :title="$t('maintenance.measures.create.title')"
            >
              <font-awesome-icon icon="plus-circle"/>
            </b-button>
          </div>
        </b-form-group>

      </b-form>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">
                <span class="text-white">
                  {{ progressMessage }}
                </span>
              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <span class="btn btn-secondary cursor-pointer"
                        @click="hideCreateMModal"
                        qid="create-m-cancel-button"
                  >
                    {{ $t('maintenance.measures.create.cancel') }}
                  </span>
                  <b-button type="submit"
                            class="ml-3"
                            variant="success"
                            @click="addMeasureFormSubmit"
                            :disabled="buttonDisabled"
                            qid="create-m-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('maintenance.measures.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>


    <!-- Create measure -->
    <b-modal ref="create-measure" @hide="hideCreateMeasureModal" modal-class="task-modal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideCreateMeasureModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="create-m-title">
            {{ $t('maintenance.measures.create.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-m-error"
      >
        {{ error }}
      </b-alert>

      <b-form @submit="createMeasureFormSubmit" qid="create-m-form">

        <b-form-group>
          <label qid="create-m-category-label">
            {{ $t('maintenance.measures.create.category_label') }}<span class="mandatory"> *</span>
          </label>
          <multiselect
              v-model="selectedMeasureCategory"
              :options="categoryItems"
              :placeholder="$t('maintenance.measures.create.category_placeholder')"
              label="name"
              :disabled="true"
              :select-label="$t('system.dropdown_select_label')"
              :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')"
              track-by="slug"
              qid="create-ac-form-ac"
          ></multiselect>
        </b-form-group>
        <b-form-group>
          <label qid="create-m-name-label">
            {{ $t('maintenance.measures.create.name_label') }}<span class="mandatory"> *</span>
          </label>
          <b-form-input
            qid="create-m-form-name"
            type="text"
            v-model="pForm.name"
            required
            :maxLength="255"
            :placeholder="$t('maintenance.measures.create.name_placeholder')"
          ></b-form-input>
        </b-form-group>

        <b-form-group>
          <label qid="create-m-description-label">
            {{ $t('maintenance.measures.create.description_label') }}
          </label>
          <b-form-textarea
            qid="create-m-form-description"
            v-model="pForm.description"
            rows="6"
            max-rows="6"
            :placeholder="$t('maintenance.measures.create.description_placeholder')"
          ></b-form-textarea>
        </b-form-group>

      </b-form>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="hideCreateMeasureModal"
                            qid="create-m-cancel-button"
                  >
                    {{ $t('maintenance.measures.create.cancel') }}
                  </b-button>
                  <b-button type="submit"
                            class="ml-3"
                            variant="success"
                            @click="createMeasureFormSubmit"
                            :disabled="buttonDisabled"
                            qid="create-m-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('maintenance.measures.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>


    <!-- Add measure category -->
    <b-modal ref="create-category" @hide="hideCreateMCModal" modal-class="task-modal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideCreateMCModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="create-m-title">
            {{ $t('projects.measures.create_section_button') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-m-error"
      >
        {{ error }}
      </b-alert>

      <b-form @submit="addMeasureCategoryFormSubmit" qid="create-m-form">
        <b-form-group>
          <span class="float-right cursor-pointer" @click="selectAllSections">
            {{ $t('projects.measures.add_all_sections') }}
          </span>
          <label qid="create-p-users-label">
            {{ $t('projects.measures.select_measure_category_label') }}
          </label>
          <div class="multiselect-row">
            <multiselect
                v-model="selectedMC"
                :options="measureCategoryItems"
                :multiple="true"
                :taggable="false"
                track-by="slug"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :placeholder="$t('projects.measures.select_measure_category_placeholder')"
                label="name"
                qid="create-p-users-select"
            >
            </multiselect>
            <b-button
                class="btn btn-secondary float-right"
                @click="showCreateMeasureCategoryModal()"
                v-b-tooltip.hover
                :title="$t('maintenance.control_objective.add_new')"
            >
              <font-awesome-icon icon="plus-circle"/>
            </b-button>
          </div>

        </b-form-group>

      </b-form>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">
                <span class="text-white">
                  {{ progressMessage }}
                </span>
              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <span class="btn btn-secondary cursor-pointer"
                        @click="hideCreateMCModal"
                        qid="create-m-cancel-button"
                  >
                    {{ $t('maintenance.measures.create.cancel') }}
                  </span>
                  <b-button type="submit"
                            class="ml-3"
                            variant="success"
                            @click="addMeasureCategoryFormSubmit"
                            :disabled="buttonDisabled"
                            qid="create-m-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('maintenance.measures.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>


    <!-- Edit measure category modal template -->
    <b-modal ref="edit-category" @hide="hideEditMCModal" modal-class="task-modal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideEditMCModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="update-tp-title">
            {{ $t('maintenance.measure_categories.update.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="edit-mc-error"
      >
        {{ error }}
      </b-alert>

      <b-form @submit="editMCFormSubmit" qid="edit-mc-form">
        <div class="form-container">
          <b-form-group>
            <label qid="edit-mc-name-label">
              {{ $t('maintenance.measure_categories.create.name_label') }}
            </label>
            <span class="text-red">*</span>
            <b-form-input
              qid="edit-mc-form-name"
              type="text"
              v-model="MCForm.name"
              :maxLength="255"
              required
              :placeholder="$t('maintenance.measures.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>

          <b-form-group>
            <label qid="edit-mc-description-label">
              {{ $t('maintenance.measures.create.description_label') }}
            </label>
            <b-form-textarea
              qid="create-mc-form-description"
              v-model="MCForm.description"
              rows="6"
              max-rows="6"
              :placeholder="$t('maintenance.measures.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>

          <b-form-group>
            <label qid="edit-mc-form-alternative">
              {{ $t('system.alternative_reporting_label') }}
            </label>
            <b-form-radio-group
                v-model="MCForm.alternative"
                :options="alternativeOptions"
            ></b-form-radio-group>
          </b-form-group>
        </div>
      </b-form>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="hideEditMCModal"
                            qid="edit-mc-cancel-button"
                  >
                    {{ $t('maintenance.measures.create.cancel') }}
                  </b-button>
                  <b-button type="submit"
                            class="ml-3"
                            variant="success"
                            @click="editMCFormSubmit"
                            :disabled="buttonDisabled"
                            qid="edit-mc-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('maintenance.measures.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>


    <!-- Delete Measure confirm modal template -->
    <b-modal ref="delete-measure" modal-class="task-modal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideConfirmDeleteModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="update-m-title">
            {{ $t('maintenance.measures.delete.title') }}
          </h5>
        </div>
      </template>
      <div class="mb-2 mt-3" style="font-size:18px;" v-if="itemToDelete && itemToDelete.measure">
        <div>
          {{ $t('maintenance.measures.delete.description') }}
          <span class="text-bold">
            {{ itemToDelete.measure.name }}
          </span>
        </div>
        <div class="mt-2">
          {{ $t('maintenance.measures.delete.are_you_sure') }}
        </div>
      </div>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <span class="btn btn-secondary cursor-pointer"
                        @click="hideConfirmDeleteModal"
                        qid="delete-p-cancel-button"
                  >
                    {{ $t('maintenance.measures.delete.cancel') }}
                  </span>
                  <b-button type="submit"
                            class="ml-3"
                            variant="danger"
                            @click="confirmDeleteM(itemToDelete)"
                            :disabled="buttonDisabled"
                            qid="delete-p-submit-button"
                  >
                    {{ $t('maintenance.measures.delete.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>



    <!-- Delete Measure category confirm modal template -->
    <b-modal ref="delete-measure-category" modal-class="task-modal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideConfirmDeleteCategoryModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="update-m-title">
            {{ $t('maintenance.measures.delete.title') }}
          </h5>
        </div>
      </template>
      <div class="mb-2 mt-3" style="font-size:18px;" v-if="itemToDelete && itemToDelete.measure_category">
        <div>
          {{ $t('maintenance.measures.delete.description') }}
          <span class="text-bold">
            {{ itemToDelete.measure_category.name }}
          </span>
        </div>
        <div class="mt-2">
          {{ $t('maintenance.measures.delete.are_you_sure') }}
        </div>
      </div>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <span class="btn btn-secondary cursor-pointer"
                        @click="hideConfirmDeleteCategoryModal"
                        qid="delete-p-cancel-button"
                  >
                    {{ $t('maintenance.measures.delete.cancel') }}
                  </span>
                  <b-button type="submit"
                            class="ml-3"
                            variant="danger"
                            @click="confirmDeleteMC(itemToDelete)"
                            :disabled="buttonDisabled"
                            qid="delete-p-submit-button"
                  >
                    {{ $t('maintenance.measures.delete.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

    </b-modal>


    <!-- Edit Measure modal template -->
    <b-modal ref="edit-measure" @hide="hideEditMModal" modal-class="task-modal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideEditMModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="update-m-title">
            {{ $t('maintenance.measures.update.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="edit-m-error"
      >
        {{ error }}
      </b-alert>

      <b-form qid="edit-m-form">
        <div class="form-container">
          <b-form-group>
            <label qid="edit-mc-name-label">
              {{ $t('maintenance.measure_categories.create.name_label') }}
            </label>
            <span class="text-red">*</span>
            <b-form-input
              qid="edit-mc-form-name"
              type="text"
              v-model="pForm.name"
              :maxLength="255"
              required
              :placeholder="$t('maintenance.measures.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="edit-m-description-label">
              {{ $t('maintenance.measures.create.description_label') }}
            </label>
            <b-form-textarea
              qid="edit-m-form-description"
              v-model="pForm.description"
              rows="6"
              max-rows="6"
              :placeholder="$t('maintenance.measures.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
        </div>
      </b-form>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="hideEditMModal"
                            qid="edit-m-cancel-button"
                  >
                    {{ $t('maintenance.measures.create.cancel') }}
                  </b-button>
                  <b-button type="submit"
                            class="ml-3"
                            variant="success"
                            @click="editMFormSubmit"
                            :disabled="buttonDisabled"
                            qid="edit-m-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('maintenance.measures.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>



    <!-- Create measure category -->
    <b-modal ref="create-measure-category" @hide="hideCreateMeasureCategoryModal" modal-class="task-modal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideCreateMeasureCategoryModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="create-mc-title">
            {{ $t('maintenance.measure_categories.create.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-mc-error"
      >
        {{ error }}
      </b-alert>

      <b-form @submit="addMeasureCategoryFormSubmit" qid="create-mc-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-mc-name-label">
              {{ $t('maintenance.measure_categories.create.name_label') }}<span class="mandatory"> *</span>
            </label>
            <b-form-input
              qid="create-mc-form-name"
              type="text"
              v-model="MCForm.name"
              :maxLength="255"
              required
              :placeholder="$t('maintenance.measure_categories.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>

          <b-form-group>
            <label qid="create-mc-description-label">
              {{ $t('maintenance.measures.create.description_label') }}
            </label>
            <b-form-textarea
              qid="create-mc-form-description"
              v-model="MCForm.description"
              rows="6"
              max-rows="6"
              :placeholder="$t('maintenance.measures.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>

          <b-form-group>
            <label qid="create-mc-form-alternative">
              {{ $t('system.alternative_reporting_label') }}
            </label>
            <b-form-radio-group
                v-model="MCForm.alternative"
                :options="alternativeOptions"
            ></b-form-radio-group>
          </b-form-group>
        </div>
      </b-form>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="hideCreateMeasureCategoryModal"
                            qid="create-mc-cancel-button"
                  >
                    {{ $t('maintenance.measures.create.cancel') }}
                  </b-button>
                  <b-button type="submit"
                            class="ml-3"
                            variant="success"
                            @click="createMeasureCategoryFormSubmit"
                            :disabled="buttonDisabled"
                            qid="create-mc-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('maintenance.measure_categories.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js';
  import draggable from 'vuedraggable'

  export default {
    name: 'MeasuresTable',
    data: function() {
      return {
        tableItems: [],

        // Pagination
        perPageOptions: [
          { name: '10', value: '10' },
          { name: '20', value: '20' },
          { name: '50', value: '50' },
          { name: '100', value: '100' }
        ],
        perPage: '',
        selectedPerPage: "10",
        currentPage: 1,
        totalRows: 0,

        partitions: [],
        clients: [],
        selectedPartition: [],
        selectedClient: [],

        itemToDelete: {},
        pForm: {
          name: '',
          description: '',
          order: 0,
          measure_category_id: '',
          measure_category_order: 0,
          value: [],
          currency: [],
          client:'',
          links: []
        },
        error: '',
        selectedSort: '',
        selectedDirection: '',
        filterOpened: false,
        keywordValue: '',
        filters: {
          category: '',
          keywordValue: ''
        },
        SideFilterRenderComponent: true,
        // TopBarRenderComponent: true,
        categoryItems: [],
        categoryItemsStaging: [],
        affected_category: {
          from: { id: '', order: '' },
          to: { id: '', order: '' }
        },
        categoryInput: '',
        valueItems: [
          { name: this.$t('maintenance.measures.values.none'), value: 'none' },
          { name: this.$t('maintenance.measures.values.date'), value: 'date' },
          { name: this.$t('maintenance.measures.values.number'), value: 'number' },
          { name: this.$t('maintenance.measures.values.dropdown'), value: 'dropdown' }
        ],
        value: [],
        currencyItems: [
          {name: 'None', value: 'None'},
          {name: 'DKK', value: 'DKK'},
          {name: 'EUR', value: 'EUR'},
          {name: 'GBP', value: 'GBP'},
          {name: 'USD', value: 'USD'}
        ],
        currency: [],
        responseTypes: [
          { name: this.$t('maintenance.questions.type.yes/no'), value: 'Yes/No' },
          { name: this.$t('maintenance.questions.type.select'), value: 'Select' }
        ],
        yesNoOptions: [
          'Yes',
          'No'
        ],
        alternativeOptions: [
          {text: this.$t('system.standard'), value: 0},
          {text: this.$t('system.alternative'), value: 1},
        ],
        responseType: [],
        selectedOptions: [],
        inputOption: '',
        positiveAnswers: [],
        negativeAnswers: [],
        allAnswers: [],
        allAnswersCopy: [],
        showInput: true,
        loading: true,
        buttonDisabled: false,
        myGuides: [],
        wpGuide: {},
        showFullGuideDescription: false,
        selectedFilter: {},
        selectedFilterName: '',
        selectedCategory: {},
        selectedMeasureCategory: [],
        selectedMC: [],
        measureCategoryItems: [],
        MCForm: {
          name: '',
          description: '',
          alternative: 0,
          scope: []
        },
        scopes: [
          { name: this.$t('projects.scope.activity'), value: 'activity' },
          { name: this.$t('projects.scope.system'), value: 'system' },
          { name: this.$t('projects.scope.third_party'), value: 'third_party' },
          { name: this.$t('projects.scope.assessment'), value: 'assessment' },
        ],
        selectedScopes: [],
        selectedMeasure: [],
        selectedMeasureCategoryObject: [],
        measureItems: [],
        updateChildList: false,
        sort: true,
        moveError: '',
        showMoveError: false,
        progressMessage: ''
      }
    },
    props: {
      object: {
        type: Object,
        required: true
      },
      showOnTask: {},
    },
    components: {
      draggable,
    },
    computed: {
      rows() {
        // Use computed value for rows because of dynamic update
        return this.totalRows
      },
      getClient() {
        return this.$store.state.client
      },
      getFilters() {
        return this.$store.state.activeFilters
      },
      getStorePerPage() {
        return this.$store.state.perPage
      },
      getWordpressLink() {
        return this.$store.state.wordpressLink
      },
      getPerPage() {
        let page = this.currentPage;
        let selectedFrom = (page-1) * Number(this.selectedPerPage) + 1;
        let selectedTo = (page-1) * Number(this.selectedPerPage) + Number(this.selectedPerPage);
        let selectedOf = this.totalRows;

        if(selectedTo > selectedOf){
          selectedTo = selectedOf
        }

        return selectedFrom + " - " + selectedTo + " " + this.$t('system.of') + " " + selectedOf
      },
      getClients() {
        let clients = [];
        if (this.$store.state.user.clients) {
          for (let i = 0; i < this.$store.state.user.clients.length; i++) {
            if (!this.$store.state.user.clients[i].parent){
              clients.push(this.$store.state.user.clients[i]);
            }
          }
          if (clients && clients.length) {
            clients.sort(function(a, b) {
              let nameA = a.name.toUpperCase(); // ignore upper and lowercase
              let nameB = b.name.toUpperCase(); // ignore upper and lowercase
              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
              // names must be equal
              return 0;
            });
          }
        }
        return clients
      },
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {
        this.loadContent();
      },
      object: function (value) {
        this.activity = value;
        if (value && value.slug) {
          this.loadContent();
        }
      },
    },
    methods: {
      debounceInput: _.debounce(function() {
        this.loadContent();
      }, 400),
      selectAllSections() {
        this.selectedMC = [];
        if (this.measureCategoryItems && this.measureCategoryItems.length) {
          this.selectedMC.push(...this.measureCategoryItems);
        }
      },
      selectAllMeasures() {
        this.selectedMeasure = [];
        if (this.measureItems && this.measureItems.length) {
          this.selectedMeasure.push(...this.measureItems);
        }
      },
      /*checkDrop(event, object) {
        this.showMoveError = true;
        this.moveError = this.$t('projects.measures.move_not_allowed');
        this.loadContent();
      },*/
      handleSearch() {
        this.selectedCategory = null;
        this.filters.category = '';
        this.debounceInput();
      },
      updateSelectedFilter(item) {
        if (!item) {
          this.filters.category = {};
          this.selectedFilterName = '';
        }else{
          this.filters.category = item;
          this.selectedFilterName = item.name;
        }

        this.selectedCategory = this.filters.category;
        this.debounceInput();
      },
      clientSelected() {
        let self = this
        setTimeout(function(){
          self.loadPartitions();
        }, 300);
      },
      loadPartitions() {
        let self = this;
        piincHttp.get('partitions', { params: {
          client: self.selectedClient && self.selectedClient.id ? self.selectedClient.slug : undefined,
          per_page: 0,
          sort: 'name',
          order: 'asc',
          mine: 1
        }}).then(function(response) {
          self.partitions = response.data.items;
        }, function() {});
      },
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope === code && object.type === 'Maintenance' && object.enabled;
        });
        return existingGuide;
      },
      loadGuides(code) {
        let self = this;

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'Maintenance',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
            piincHttp.get(self.getWordpressLink + self.myGuides[0].external_id).then(function(response) {
              self.wpGuide = response.data;
            }, function() {});
          }
        }, function() {});
      },
      setFilterCategory(item) {
        this.filters.category = item;
        this.selectedFilterName = item.name;
        this.debounceInput();
      },
      resetFilters() {
        this.filters.category = '';
        this.debounceInput();
      },
      handleCategoryInput(input) {
        this.categoryInput = input;
      },
      selectSort(sort) {
        // If old and new sort are same, switch just direction
        if (sort === this.selectedSort) {
          this.selectedDirection = this.selectedDirection === 'desc' ? 'asc' : 'desc';
        } else {
          // If different sort, set sort and set direction to default
          this.selectedDirection = 'desc'
          this.selectedSort = sort;
        }
        this.loadContent();
      },
      postOrderCategories() {
        let self = this;
        let order = [];

        self.loading = true;
        self.buttonDisabled = true;

        _.forEach(this.categoryItems, function (item, index) {
          order.push({
            id: item.id,
            position: index + 1
          });
        })
        piincHttp.post('projects/' + this.activity.slug + '/categories/order', {
          order: order
        }).then(function() {
          self.updateCategoryOrder(0);

          self.loading = false;
          self.buttonDisabled = false;
        }, function(error) {
          if (error.status !== 200) {
            self.loading = false;
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })
      },
      postOrderMeasures(event, object) {
        let self = this;
        let order = [];

        self.loading = true;
        self.buttonDisabled = true;

        if(!self.affected_category.to.id) {
          self.affected_category.to.id = object.measure_category_id;
          self.affected_category.to.order = object.order;
        }else{
          self.affected_category.from.id = object.measure_category_id;
          self.affected_category.from.order = object.order;
        }

        _.forEach(object.measureItems, function (item, index) {
          order.push({
            id: item.id,
            position: index + 1
          });

          if (item.project_category && item.project_category.id && item.project_category.id !== object.id) {
            piincHttp.put('projects/' + self.activity.slug + '/measures/' + item.id, {
              project_category_id: object.id,
            }).then(function() {
              _.forEach(self.categoryItems[object.order - 1].measureItems, function (measure_item, measure_index) {
                if(measure_item.measure.id === item.measure.id) {
                  self.categoryItems[object.order - 1].measureItems[measure_index].project_category.id = object.id;
                  self.categoryItems[object.order - 1].measureItems[measure_index].project_category.order = object.order;
                  self.categoryItems[object.order - 1].measureItems[measure_index].project_category.measure_category_id = object.measure_category.id;

                  self.categoryItems[object.order - 1].measureItems[measure_index].project_category.measure_category.id = object.measure_category.id;
                  self.categoryItems[object.order - 1].measureItems[measure_index].project_category.measure_category.slug = object.measure_category.slug;
                  self.categoryItems[object.order - 1].measureItems[measure_index].project_category.measure_category.name = object.measure_category.name;
                  self.categoryItems[object.order - 1].measureItems[measure_index].project_category.measure_category.description = object.measure_category.description;
                }
              })
            }, function(error) {
              if (error.status !== 200) {
                self.buttonDisabled = false;
                self.error = error.data.message;
              }
            })
          }
        })

        piincHttp.post('projects/' + this.activity.slug + '/measures/order', {
          project_category_id: object.id,
          order: order
        }).then(function() {
          self.updateMeasureOrder();
          self.loading = false;
          self.buttonDisabled = false;
        }, function(error) {
          if (error.status !== 200) {
            self.affected_category.from.id = '';
            self.affected_category.to.id = '';
            self.affected_category.from.order = '';
            self.affected_category.to.order = '';

            self.buttonDisabled = false;
            self.loading = false;

            self.error = error.data.message;
          }
        })
      },
      updateMeasureOrder() {
        let self = this;
        let from_order = 0;
        let to_order = 0;

        if(self.affected_category.to.order) {
          _.forEach(self.categoryItems[self.affected_category.to.order - 1].measureItems, function () {
            to_order = to_order + 1;
            self.categoryItems[self.affected_category.to.order - 1].measureItems[to_order - 1].order = to_order;
          })

          if(   self.affected_category.to.id
             && self.affected_category.from.id
             && self.affected_category.from.order
             && self.affected_category.from.id !== self.affected_category.to.id
          ) {
            _.forEach(self.categoryItems[self.affected_category.from.order - 1].measureItems, function () {
              from_order = from_order + 1;
              self.categoryItems[self.affected_category.from.order - 1].measureItems[from_order - 1].order = from_order;
            })
          }
        }
      },
      updateCategoryOrder(start_order) {
        let self = this;

        _.forEach(self.categoryItems, function (category, category_index) {
          if(category_index + 1 >= start_order) {
            self.categoryItems[category_index].order = category_index + 1;

            _.forEach(category.measureItems, function (measure, measure_index) {
              self.categoryItems[category_index].measureItems[measure_index].project_category.order = category_index + 1;
            })
          }
        })
      },
      addMeasure(object, category_order, measure_order) {
        let self = this;
        let mo = 0;

        if(measure_order) {
          mo = measure_order;
        }

        self.categoryItems[category_order - 1].measureItems.splice(mo, 0, object);
      },
      updateMeasure(object, category_order, measure_order) {
        let self = this;
        self.categoryItems[category_order - 1].measureItems[measure_order - 1].measure = object;
      },
      removeMeasure(category_order, measure_order) {
        let self = this;
        self.categoryItems[category_order - 1].measureItems.splice(measure_order - 1, 1);

        self.affected_category.to.order = category_order;
        self.updateMeasureOrder();
        self.affected_category.to.order = '';
      },
      addCategory(item, object) {
        let new_object = {};
        if (this.categoryItems && this.categoryItems.length) {
          new_object.id = item.id;
          new_object.order = item.order;
          new_object.expanded = false;
          new_object.project_id = this.categoryItems[0].project_id;
          new_object.measure_category_id = item.measure_category_id;
          new_object.measureItems = [];
          new_object.measure_category = object;
          this.categoryItems.splice(new_object.order, 0, new_object);
        } else {
          this.loadContent();
        }
      },
      /*updateCategory(object, category_order) {
        let self = this;
        self.categoryItems[category_order - 1].measureItems[measure_order - 1].measure = object;
      },*/
      removeCategory(category_order) {
        let self = this;
        self.categoryItems.splice(category_order - 1, 1);

        self.updateCategoryOrder(category_order);
      },
      loadContent() {
        let self = this;

        self.loading = true;

        piincHttp.get('projects/' + self.activity.slug + '/categories', { params:
          {
            per_page: 100,
            client: self.getClient.slug
          }
        }).then(function(response) {
          self.categoryItemsStaging = [];

          if (!response.data.items.length) {
            self.loading = false;
          }

          _.forEach(response.data.items, function(item, key) {

            // Set initial expanded value on category object
            item.expanded = false;

            piincHttp.get('projects/' + self.activity.slug + '/measures', { params:
              {
                per_page: 100,
                project_category: item.id,
                client: self.getClient.slug
              }
            }).then(function(responseMeasure) {
              // Set initial expanded value for each measure object
              _.forEach(responseMeasure.data.items, function (object) {
                object.expanded = false;
              })
              item.measureItems = responseMeasure.data.items;
              self.categoryItemsStaging.splice(key, 0, item)
              self.categoryItemsStaging = _.sortBy(self.categoryItemsStaging, ['order']);

              if(key === response.data.items.length - 1) {
                setTimeout(function() {
                  self.categoryItems = self.categoryItemsStaging
                  self.loading = false;
                }, 5000);
              }
            }, function() {});
          });
        }, function() {});
      },
      showConfirmDeleteModal(object) {
        this.itemToDelete = object;
        this.$refs['delete-measure'].show();
      },
      hideConfirmDeleteModal() {
        this.itemToDelete = {};
        this.$refs['delete-measure'].hide();
      },
      showConfirmDeleteCategoryModal(object) {
        this.itemToDelete = object;
        this.$refs['delete-measure-category'].show();
      },
      hideConfirmDeleteCategoryModal() {
        this.itemToDelete = {};
        this.$refs['delete-measure-category'].hide();
      },
      showEditMCModal(object) {
        let self = this;
        self.selectedScopes = [];
        this.error = '';

        if (object.measure_category && object.measure_category.scope && object.measure_category.scope.length) {
          _.forEach(object.measure_category.scope, function (value) {
            _.find(self.scopes, function(item) {
              if (item.value === value) {
                self.selectedScopes.push(item);
              }
            });
          })
        }

        this.MCForm.slug = object.measure_category.slug;
        this.MCForm.name = object.measure_category.name;
        this.MCForm.description = object.measure_category.description;

        if (this.MCForm && (this.MCForm.alternative === 0 || this.MCForm.alternative === 1)) {
          this.MCForm.alternative = object.measure_category.alternative;
        } else {
          this.MCForm.alternative = 0;
        }

        this.$refs['edit-category'].show();
      },
      hideEditMCModal() {
        this.error = '';
        this.selectedScopes = [];
        this.$refs['edit-category'].hide();
      },
      editMCFormSubmit(evt) {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();
        let scopes = [];

        // Append list of types
        if (this.selectedScopes && this.selectedScopes.length) {
          for (let i = 0; i < this.selectedScopes.length; i++) {
            scopes.push(this.selectedScopes[i].value);
          }
        }

        this.MCForm.client = this.getClient.slug;
        this.MCForm.scope = scopes;

        if (this.MCForm.name && this.MCForm.name.length) {
          piincHttp.put('measure-categories/' + this.MCForm.slug, this.MCForm).then(function(response) {
            self.hideEditMCModal();
            self.loadContent();
            self.buttonDisabled = false;
            // Store new value from API for updated category
            self.dataSelectedCategory = response.data;
            // Emit event together with new value
            self.$toastr('success', self.$t('maintenance.measure_categories.update.success'));
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          })
        } else {
          this.buttonDisabled = false;
          this.error = '';
          if (this.MCForm.name === '') {
            this.error +=  ' ' + this.$t('maintenance.incidents.incident_categories.create.name_error');
          }
        }
      },
      // Create measure methods
      showCreateMModal(object) {
        this.selectedMeasure = [];
        this.selectedMeasureCategoryObject = object;
        this.progressMessage = '';
        this.loadMeasureItems(object);
        this.error = '';
        this.$refs['add-measure'].show();
      },
      hideCreateMModal() {
        this.selectedMeasure = [];
        this.progressMessage = '';
        this.selectedMeasureCategoryObject = [];
        this.$refs['add-measure'].hide();
      },
      // Create measure methods
      showCreateMeasureModal() {
        this.pForm.name = '';
        this.pForm.scope = [];
        this.pForm.links = [];
        this.pForm.value = [];
        this.pForm.currency = [];
        this.pForm.description = '';
        this.selectedScopes = [];
        this.selectedFiles = [];
        this.responseType = [];
        this.selectedOptions = [];
        this.inputOption = '';
        this.positiveAnswers = [];
        this.allAnswers = [];
        this.allAnswersCopy = [];
        this.showInput = true;
        this.currency = [];
        this.selectedMeasureCategory = this.selectedMeasureCategoryObject.measure_category;
        this.error = '';
        this.$refs['create-measure'].show();
      },
      hideCreateMeasureModal() {
        this.pForm.name = '';
        this.pForm.scope = [];
        this.$refs['create-measure'].hide();
      },
      createMeasureFormSubmit(evt) {
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        this.loading = true;
        this.buttonDisabled = true;
        this.updateChildList = false;
        this.pForm.client = this.getClient.slug;

        if (this.selectedMeasureCategory && this.selectedMeasureCategory.id) {
          this.pForm.measure_category_id = this.selectedMeasureCategory.id;
        } else {
          this.pForm.measure_category_id = '';
        }

        this.pForm.value = 'none';

        if (
          (this.selectedMeasureCategory && this.selectedMeasureCategory.id) &&
          (this.pForm.name && this.pForm.name.length)
        ){

          //Post to create measure
          piincHttp.post('measures/', {
            name: this.pForm.name,
            description: this.pForm.description,
            value: this.pForm.value,
            measure_category_id: this.pForm.measure_category_id,
            client: this.getClient.slug
          }).then(function(response) {

            //Post to add measure to project
            piincHttp.post('projects/' + self.activity.slug + '/measures', {
              measure_id: response.data.id,
              project_category_id: self.selectedMeasureCategoryObject.id,
            }).then(function(response) {
              self.hideCreateMModal();
              self.hideCreateMeasureModal();
              self.addMeasure(response.data, response.data.project_category.order, response.data.order);

              self.loading = false;
              self.buttonDisabled = false;
              self.$toastr('success', self.$t('maintenance.measures.create.success'));
            }, function(error) {
              if (error.status !== 200) {
                self.buttonDisabled = false;
                self.error = error.data.message;
                if (error.data.errors.measure_id) {
                  self.error += ' ' + error.data.errors.measure_id[0];
                }
              }
            })

          }, function(error) {
            if (error.status !== 200) {
              self.loading = false;
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          })
        } else {
          this.error = '';
          this.loading = false;
          this.buttonDisabled = false;

          if (this.pForm.name === '') {
            this.error +=  ' ' + this.$t('maintenance.incidents.incident_categories.create.name_error');
          }
          if (!this.selectedMeasureCategory || !this.selectedMeasureCategory.id) {
            this.error +=  ' ' + this.$t('system.category_error_message');
          }
        }
      },
      // Create new measure category methods
      showCreateMeasureCategoryModal() {
        this.error = '';
        this.MCForm.name = '';
        this.MCForm.description = '';
        this.MCForm.alternative = 0;
        this.MCForm.scope = [];
        this.selectedScopes = [];
        this.$refs['create-measure-category'].show();
      },
      hideCreateMeasureCategoryModal() {
        this.error = '';
        this.MCForm.name = '';
        this.MCForm.description = '';
        this.MCForm.alternative = 0;
        this.MCForm.scope = [];
        this.selectedScopes = [];
        this.$refs['create-measure-category'].hide();
      },
      createMeasureCategoryFormSubmit(evt) {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        this.MCForm.client = this.getClient.slug;
        this.MCForm.scope = ['assessment'];

        if (this.MCForm.scope.length && this.MCForm.name && this.MCForm.name.length) {
          piincHttp.post('measure-categories', this.MCForm).then(function(response) {
            piincHttp.post('projects/' + self.activity.slug + '/categories', {
              measure_category_id: response.data.id
            }).then(function(order_response) {
              self.hideCreateMeasureCategoryModal();
              self.hideCreateMCModal();

              self.addCategory(order_response, response.data);

              self.$toastr('success', self.$t('maintenance.measure_categories.create.success'));
              self.buttonDisabled = false;
            }, function(error) {
              if (error.status !== 200) {
                self.buttonDisabled = false;
                self.error = error.data.message;
                if (error.data.errors.measure_category_id) {
                  self.error += ' ' + error.data.errors.measure_category_id[0];
                }
              }
            })

          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          })
        } else {
          this.buttonDisabled = false;
          this.error = '';
          if (this.MCForm.name === '') {
            this.error +=  ' ' + this.$t('maintenance.incidents.incident_categories.create.name_error');
          }
        }
      },
      addMeasureFormSubmit(evt) {
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        this.loading = true;
        this.buttonDisabled = true;
        this.updateChildList = false;
        this.pForm.client = this.getClient.slug;

        if (this.selectedMeasure && this.selectedMeasure.length) {
          for (let i = 0; i < this.selectedMeasure.length; i++) {
            setTimeout(function() {

              let position = i + 1;
              // Updating progress message before every pass of API call
              self.progressMessage = self.$t('projects.measures.adding_measures_label') + ' ' + position + '/' + self.selectedMeasure.length + '...'

              piincHttp.post('projects/' + self.activity.slug + '/measures', {
                measure_id: self.selectedMeasure[i].id,
                project_category_id: self.selectedMeasureCategoryObject.id,
              }).then(function(response) {
                self.addMeasure(response.data, response.data.project_category.order, response.data.order);

                if (position === self.selectedMeasure.length) {
                  self.hideCreateMModal();
                  self.loading = false;
                  self.buttonDisabled = false;
                  self.updateChildList = true;
                  self.$toastr('success', self.$t('projects.measures.add_measure_success'));
                }

              }, function(error) {
                if (error.status !== 200) {
                  self.loading = false;
                  self.buttonDisabled = false;
                  self.error = error.data.message;

                  if (error.data.errors.measure_id) {
                    self.error += ' ' + error.data.errors.measure_id[0];
                  }
                }
              })
            }, i * 800);
          }
        } else {
          this.error = '';
          this.loading = false;
          this.buttonDisabled = false;

          if (!this.selectedMeasure || !this.selectedMeasure.id) {
            this.error +=  ' ' + this.$t('system.measure_error_message');
          }
        }
      },
      addMeasureCategoryFormSubmit(evt) {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        if (this.selectedMC && this.selectedMC.length) {
          for (let i = 0; i < this.selectedMC.length; i++) {
            setTimeout(function() {
              let position = i + 1;
              // Updating progress message before every pass of API call
              self.progressMessage = self.$t('projects.measures.adding_sections_label') + ' ' + position + '/' + self.selectedMC.length + '...';

              piincHttp.post('projects/' + self.activity.slug + '/categories', {
                measure_category_id: self.selectedMC[i].id
              }).then(function(response) {
                // If last pass, hide modal and load new content
                if (i === self.selectedMC.length - 1) {
                  self.hideCreateMCModal();
                  self.addCategory(response.data, self.selectedMC[i]);
                  self.buttonDisabled = false;
                  self.$toastr('success', self.$t('projects.measures.add_measure_category_success'));
                }
              }, function(error) {
                if (error.status !== 200) {
                  self.buttonDisabled = false;
                  self.error = error.data.message;
                  if (error.data.errors.measure_category_id) {
                    self.error += ' ' + error.data.errors.measure_category_id[0];
                  }
                }
              })
            }, i * 800);
          }
        } else {
          this.error = '';
          this.buttonDisabled = false;

          if (!this.selectedMC || !this.selectedMC.id) {
            this.error +=  ' ' + this.$t('projects.measures.measure_category_error_message');
          }
        }
      },
      showEditMModal(measure_item) {
        let self = this;
        let object = measure_item.measure;

        this.error = '';

        // Preselect category on edit modal
        this.selectedMeasureCategory = {}
        if (object.measure_category) {
          _.find(this.categoryItems, function(item) {
            if (item.id === object.measure_category.id) {
              self.selectedMeasureCategory = object.measure_category;
            }
          });
        }

        this.selectedMeasureCategory = object.measure_category;

        this.pForm.value = [];
        if (object.value) {
          this.pForm.value = _.find(this.valueItems, function(item) {
            return item.value === object.value;
          });
        }

        this.pForm.currency = [];
        if (object.currency) {
          this.pForm.currency = _.find(this.currencyItems, function(item) {
            return item.value === object.currency;
          });
        }

        this.responseType = [];
        if (object.type) {
          this.responseType = _.find(this.responseTypes, function(item) {
            return item.value === object.type;
          });

          if (object.type === 'Select') {
            this.allAnswers = this.selectedOptions;
            this.allAnswersCopy = _.cloneDeep(this.allAnswers);
          } else {
            this.allAnswers = this.yesNoOptions;
            this.allAnswersCopy = _.cloneDeep(this.allAnswers);
          }
        }

        this.positiveAnswers = []
        if (object.type_positive_response) {
          let array = JSON.parse(object.type_positive_response);
          this.positiveAnswers.push(...array);
        }

        if (object.type === 'Select') {
          this.selectedOptions = [];
          if (object.type_options) {
            let array = JSON.parse(object.type_options);
            this.selectedOptions.push(...array);
          }
        }

        this.pForm.slug = object.slug;
        this.pForm.name = object.name;
        this.pForm.description = object.description;
        this.pForm.order = measure_item.order;
        this.pForm.measure_category_order = measure_item.project_category.order;
        this.$refs['edit-measure'].show();
      },
      hideEditMModal() {
        this.error = '';
        this.categoryInput = '';
        this.selectedOptions = [];
        this.inputOption = '';
        this.positiveAnswers = [];
        this.allAnswers = [];
        this.showInput = true;
        this.responseType = [];
        this.$refs['edit-measure'].hide();
      },

      // Create Measure category
      showCreateMCModal() {
        this.loadMeasureCategoryItems();
        this.selectedMC = [];
        this.progressMessage = '';
        this.error = '';
        this.$refs['create-category'].show();
      },
      hideCreateMCModal() {
        this.error = '';
        this.progressMessage = '';
        this.$refs['create-category'].hide();
      },
      loadMeasureItems(object) {
        let self = this;
        this.measureItems = [];
        piincHttp.get('measures', { params:
          {
            per_page: 100,
            measure_category: object.measure_category.id,
            client: this.getClient.slug
          }
        }).then(function(response) {
          _.forEach(response.data.items, function (item) {
            if (_.findIndex(self.selectedMeasureCategoryObject.measureItems, function(o) { return o.measure.id === item.id }) === -1) {
              self.measureItems.push(item);
            }
          })
        }, function() {});
      },
      loadMeasureCategoryItems() {
        let self = this;
        this.measureCategoryItems = [];
        piincHttp.get('measure-categories', { params:
          {
            per_page: 100,
            scope: 'assessment',
            client: this.getClient.slug
          }
        }).then(function(response) {
          _.forEach(response.data.items, function (item) {
            if (_.findIndex(self.categoryItems, function(o) { return o.measure_category.id === item.id }) === -1) {
              self.measureCategoryItems.push(item);
            }
          })
        }, function() {});
      },
      editMFormSubmit(evt) {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();
        this.updateChildList = false;
        this.pForm.client = this.getClient.slug;

        if (this.selectedMeasureCategory && this.selectedMeasureCategory.id) {
          this.pForm.measure_category_id = this.selectedMeasureCategory.id;
        } else {
          this.pForm.measure_category_id = '';
        }

        if (this.responseType && this.responseType.value) {
          this.pForm.type = this.responseType.value;
        }

        if (this.selectedOptions && this.selectedOptions.length) {
          this.pForm.type_options = JSON.stringify(this.selectedOptions);
        } else {
          this.pForm.type_options = '[]';
        }

        if (this.positiveAnswers && this.positiveAnswers.length) {
          this.pForm.type_positive_response = JSON.stringify(this.positiveAnswers);
        } else {
          this.pForm.type_positive_response = '[]';
        }

        this.pForm.value = this.pForm.value ? this.pForm.value.value : '';
        this.pForm.currency = this.pForm.currency ? this.pForm.currency.value : '';

        piincHttp.put('measures/' + this.pForm.slug, this.pForm).then(function(response) {
          self.hideEditMModal();
          self.updateMeasure(response.data, self.pForm.measure_category_order, self.pForm.order);
          self.buttonDisabled = false;
          self.updateChildList = true;
          self.$toastr('success', self.$t('maintenance.measures.update.success'));
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
            if (error.data.errors.measure_id) {
              self.error += ' ' + error.data.errors.measure_id[0];
            }
          }
        })
      },
      confirmDeleteM(object) {
        let self = this;

        this.updateChildList = false;
        self.loading = true;
        self.buttonDisabled = true;

        piincHttp.delete('projects/' + this.activity.slug + '/measures/' + object.id).then(function() {
          self.hideConfirmDeleteModal();
          self.removeMeasure(object.project_category.order, object.order);

          // Trigger toastr message after modal close
          self.loading = false;
          self.buttonDisabled = false;
          self.$toastr('success', self.$t('maintenance.measures.delete.success'));
        }, function() {});
      },
      confirmDeleteMC(object) {
        let self = this;

        this.updateChildList = false;
        self.loading = true;
        self.buttonDisabled = true;

        piincHttp.delete('projects/' + this.activity.slug + '/categories/' + object.id).then(function() {
          self.hideConfirmDeleteCategoryModal();
          self.removeCategory(object.order);

          // Trigger toastr message after modal close
          self.loading = false;
          self.buttonDisabled = false;
          self.$toastr('success', self.$t('projects.measures.delete_section_success'));
        }, function() {});
      }
    },
    created () {
      this.activity = this.object;
      if (this.getClient && this.getClient.slug) {
        if (this.getFilters.measures) {
          this.filters = this.getFilters.measures;
          this.filters.category = '';
        }

      }
      if (this.activity && this.activity.id) {
        this.loadContent();
      }
      this.loadGuides('measures_list');
      this.loadGuides('create_measure');
    }
  }
</script>
